import React from 'react';
import { VideoDetail } from '../components/VideoDetail';
import { translator } from '../helpers/translator';


export function Video({ items, lang }) {
 const sectionTitle = translator('video_files', lang);
 if(!items.length) return null;
 return (<VideoDetail items={items} title={sectionTitle}></VideoDetail>)
}